<ul class="navigation__list-dropdown">
  @for (child of item.childLinks; track $index) {
    @if (!child.hidden) {
      <li class="navigation__list-item navigation__list-item--second-level">
        <a
          class="navigation__list-item-link"
          data-gtmaction="event_menu_click"
          data-gtmcategory="event_informational_action"
          [routerLink]="[child.linkedPage]"
          (click)="clickItem(); gtmEvent($event)"
        >
          @if (child.image && isVisible) {
            <div class="navigation__list-item-img">
              <img
                class="ls-is-cached lazyloaded category-img"
                aria-hidden="true"
                tabindex="-1"
                ngSrcset="160w, 40w"
                width="160"
                height="160"
                placeholder
                [ngSrc]="child.image"
                [alt]="child.title"
                [loaderParams]="{ builder: !child?.skipOptimization }"
              />
            </div>
          }
          <span class="circle-arrow-before" [innerHtml]="child.title"></span>
        </a>
      </li>
    }
  }
  <li class="bottom_link">
    @if (item.linkedPage) {
      <a
        class="btn-underline-hov"
        data-gtmaction="event_menu_click"
        data-gtmcategory="event_informational_action"
        [routerLink]="[item.linkedPage]"
        (click)="clickItem(); gtmEvent($event)"
        i18n="@@SEE_ALL_PRODUCTS"
      >
        See all products
      </a>
    }
  </li>
</ul>
